import { Box, styled } from '@mui/material';

export const Badge = styled(Box)(({ theme }) => ({
  width: 10,
  height: 10,
  borderRadius: '50%',
  backgroundColor: theme.palette.accent.main,
  border: '2px solid #fff',
  zIndex: 1,
}));
